/* eslint-disable */
import { Button } from '../../Components/ui/button'
import EmptyState from '../../Components/Common/EmptyState'
import { toCurrency } from '../../utils/CurrencyUtil'
import tick from '../../assets/PaymentGateway/Frame 354190.svg'
import mandateEmptyIcon from '../../assets/SVGS/action-center-mandates-empty.svg'
import env from '../../env/env'
import { AccountBalance } from '@mui/icons-material'
import { useState } from 'react'

const BankAccountItem = ({ bank, isSelected, onSelect, tickIcon, bankLogosUrl }) => {
  const [iconSrc, setIconSrc] = useState(() => {
    const branch = bank.ifscCode?.match(/^[A-Za-z]{4}/)?.[0]?.toLowerCase()
    return branch ? `${bankLogosUrl}/${branch}/symbol.svg` : null
  })
  return (
    <div
      onClick={(e) => {
        e.stopPropagation()
        onSelect(bank.accountNo)
      }}
      className={`flex w-full cursor-pointer items-center gap-4 rounded-lg border p-4 transition-all duration-200 ease-in-out ${
        isSelected
          ? 'border-primary-600 bg-primary-50'
          : 'border-black-200 bg-white hover:bg-black-50'
      }`}
    >
      <div className='flex-shrink-0'>
        {iconSrc ? (
          <span className='flex h-10 w-10 items-center justify-center rounded-lg border border-black-200 bg-white'>
            <img
              src={iconSrc}
              alt='bank logo'
              onError={() => setIconSrc(null)}
              height={24}
              width={24}
            />
          </span>
        ) : (
          <span className='flex h-10 w-10 items-center justify-center rounded-lg border border-black-200 bg-white'>
            <AccountBalance className='text-primary-600' />
          </span>
        )}
      </div>
      <div className='flex min-w-0 flex-col'>
        <span className='truncate font-IBM font-bold text-black-950'>{bank.accountHolderName}</span>
        <span className='text-xs text-black-600'>
          {bank.bankName} A/c ending in <strong> {bank.accountNo?.slice(-4)}</strong>
        </span>
      </div>

      <div className='ml-auto flex-shrink-0'>
        <div className='flex h-6 w-6 items-center justify-center'>
          {isSelected ? (
            <img src={tickIcon} alt='' />
          ) : (
            <span
              className='box-border block h-5 w-5 shrink-0 rounded-full border-2 border-black-300 bg-transparent'
              aria-hidden
            />
          )}
        </div>
      </div>
    </div>
  )
}

const MANDATE_DESCRIPTION_TEXT =
  'An ICCL Mandate is a secure payment authorization that allows the Indian Clearing Corporation Limited (ICCL), a subsidiary of the Bombay Stock Exchange (BSE), to automatically debit funds from your bank account for investments such as Mutual Funds and SIPs. Please note that the mandate is registered in favor of ICCL and not Fabits. At no point does Fabits receive or hold your funds.'

const MandateDescription = () => (
  <>
    An ICCL Mandate is a secure payment authorization that allows the Indian Clearing Corporation
    Limited (ICCL), a subsidiary of the Bombay Stock Exchange (BSE), to automatically debit funds
    from your bank account for investments such as Mutual Funds and SIPs.
    <br />
    <br />
    Please note that the mandate is registered in favor of ICCL and not Fabits. At no point does
    Fabits receive or hold your funds.
  </>
)

const MANDATE_DESCRIPTION_PREVIEW_LENGTH = 140

const Mandates = ({
  mandateResult,
  mandateRegistration,
  mandateLoading,
  mandates,
  bankAccountsList,
  selectedBank,
  setSelectedBank,
}) => {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false)

  return (
    <div className='mx-4 mt-3 pb-48 md:mx-auto md:max-w-[760px] lg:max-w-[1128px]'>
      {mandateResult && (
        <div className='mb-4'>
          <h1 className='mt-4 flex items-center justify-between'>
            <span className='font-IBM text-xl font-bold text-black-950 md:text-2xl'>
              Your Mandates
            </span>
          </h1>
          <p className='mt-1 font-DMSans text-sm font-normal text-black-500 md:text-base'>
            Complete mandate to start your investment journey.
          </p>
        </div>
      )}

      {mandateResult ? (
        <div className='fabits-card overflow-hidden p-4 transition-all duration-300 ease-in-out md:p-5'>
          <div className='flex justify-between'>
            <div className='flex items-start gap-3'>
              <div className='font-IBM text-base font-bold text-black-950 md:text-lg'>
                Mandate Amount
              </div>
            </div>
            <div className='flex items-center font-IBM font-bold text-black-950'>
              <span className='mr-2 flex items-end font-DMSans text-xl font-extrabold md:text-2xl'>
                ₹
              </span>
              <span className='text-xl md:text-2xl'>{toCurrency(mandateResult?.amount)}</span>
            </div>
          </div>
          <p className='mt-4 text-sm leading-relaxed text-black-600'>
            {isDescriptionExpanded ? (
              <MandateDescription />
            ) : (
              `${MANDATE_DESCRIPTION_TEXT.slice(0, MANDATE_DESCRIPTION_PREVIEW_LENGTH).trimEnd()}… `
            )}
            <br />
            <button
              type='button'
              onClick={() => setIsDescriptionExpanded((prev) => !prev)}
              className='mt-2 inline font-semibold text-primary-600 hover:text-primary-700'
            >
              {isDescriptionExpanded ? 'View less' : 'View more'}
            </button>
          </p>
        </div>
      ) : (
        <EmptyState
          icon={
            <span
              aria-hidden='true'
              className='fabits-action-center-empty-graphic'
              style={{ '--fabits-empty-graphic-url': `url(${mandateEmptyIcon})` }}
            />
          }
          title='All Set!'
          description={
            <span className='mx-auto block max-w-[520px] leading-relaxed'>
              You have <span className='fabits-marker'>no pending mandates</span>. All your payment
              authorizations are <span className='fabits-marker'>active and working</span>.
            </span>
          }
        />
      )}

      {mandateResult && (
        <div className='fabits-bottom-sheet fixed bottom-0 left-0 right-0 z-10 mx-auto mt-2 p-4 lg:max-w-[1128px]'>
          {bankAccountsList.length > 1 && (
            <p className='mb-2 px-2 text-left font-DMSans text-sm font-semibold leading-[18px] text-black-700'>
              Select a bank account to continue
            </p>
          )}
          <div className='space-y-2'>
            {bankAccountsList.map((bank) => (
              <BankAccountItem
                key={bank.accountNo}
                bank={bank}
                isSelected={selectedBank === bank.accountNo}
                onSelect={setSelectedBank}
                tickIcon={tick}
                bankLogosUrl={env.BANK_LOGOS}
              />
            ))}
          </div>

          <Button
            disabled={!selectedBank}
            className='mb-safe mt-4 w-full bg-primary-600 disabled:bg-primary-300'
            onClick={() => mandateRegistration(mandates?.data)}
            loading={mandateLoading}
          >
            Approve Mandate
          </Button>
        </div>
      )}
    </div>
  )
}

export default Mandates
